'use strict';
'use es6';

/*
 * Message Descriptor Sources
 *
 * THIS_CLIENT:
 *
 * The message originated from this client. This is the initial source for
 * every message that a client publishes.
 *
 * MESSAGE_LISTENER:
 *
 * The message was received through the message listener. This is the
 * initial source for messages received from other clients. Messages that
 * originate with this client will eventually be overwritten with a message
 * received through the message listener.
 *
 * HISTORY_API:
 *
 * The message was received in a response from a GET of messages/v2/history.
 *
 * CONVERSATION_OBJECT:
 *
 * The message was received in the conversation object returned by a GET of
 * messages/v2/conversation.
 *
 * SUPPLEMENTAL_INITIAL_MESSAGE:
 *
 * The message was received from an integrator as a supplement to the initial message.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var THIS_CLIENT = exports.THIS_CLIENT = 'THIS_CLIENT';
var MESSAGE_LISTENER = exports.MESSAGE_LISTENER = 'MESSAGE_LISTENER';
var HISTORY_API = exports.HISTORY_API = 'HISTORY_API';
var CONVERSATION_OBJECT = exports.CONVERSATION_OBJECT = 'CONVERSATION_OBJECT';
var SUPPLEMENTAL_INITIAL_MESSAGE = exports.SUPPLEMENTAL_INITIAL_MESSAGE = 'SUPPLEMENTAL_INITIAL_MESSAGE';